<template>
  <div>
    <!-- 搜索模块-Start -->
    <b-overlay
      :show="loading"
      rounded="sm"
    >
      <b-row>
        <b-col
          v-for="(col, col_i) in columnsBase"
          :key="col.field || col_i"
          :md="getSearchSpan(col)"
        >
          <b-form-group>
            <my-tooltip
              :tooltip="col.SearchTooltip"
              show-icon
            >
              <label>{{ col.label }}:</label>
            </my-tooltip>
            <div v-if="col.searchSlot">
              <slot
                :name="`${col.field}Search`"
              />
            </div>
            <element-component
              v-else
              v-model="searchForm[col.field]"
              :label="col.label"
              :option="col"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-button
          style="margin-left:10px;"
          variant="outline-primary"
          class="btn"
          @click="searchReset"
        >
          <feather-icon
            icon="RefreshCcwIcon"
            size="16"
          />
          {{ i18n("btns.reset") }}
        </b-button>

        <b-button
          style="margin-left:10px;"
          variant="primary"
          class="btn"
          @click="searchChange"
        >
          <feather-icon
            icon="SearchIcon"
            size="16"
          />
          {{ i18n("btns.search") }}
        </b-button>
      </b-row>
    </b-overlay>
    <!-- <b-card-btn
      :title="i18n('searchCardTitle')"
      :body-visible="visible"
      :btn-visible="columnsOther.length>0"
    >
      <template slot="base">
        <b-row>
          <b-col
            v-for="(col, col_i) in columnsBase"
            :key="col.field || col_i"
            :md="getSearchSpan(col)"
          >
            <b-form-group>
              <my-tooltip
                :tooltip="col.SearchTooltip"
                show-icon
              >
                <label>{{ col.label }}:</label>
              </my-tooltip>
              <div v-if="col.searchSlot">
                <slot
                  :name="`${col.field}Search`"
                />
              </div>
              <element-component
                v-else
                v-model="searchForm[col.field]"
                :label="col.label"
                :option="col"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </template>
      <template slot="btns">
        <b-button
          style="margin-left:10px;"
          variant="outline-primary"
          class="btn"
          @click="searchReset"
        >
          <feather-icon
            icon="RefreshCcwIcon"
            size="16"
          />
          {{ i18n("btns.reset") }}
        </b-button>

        <b-button
          style="margin-left:10px;"
          variant="primary"
          class="btn"
          @click="searchChange"
        >
          <feather-icon
            icon="SearchIcon"
            size="16"
          />
          {{ i18n("btns.search") }}
        </b-button>
      </template>
      <b-row>
        <b-col
          v-for="(col, col_i) in columnsOther"
          :key="col.field || col_i"
          :md="getSearchSpan(col)"
        >
          <b-form-group>
            <my-tooltip
              :tooltip="col.SearchTooltip"
              show-icon
            >
              <label>{{ col.label }}:</label>
            </my-tooltip>
            <div v-if="col.searchSlot">
              <slot
                :name="`${col.field}Search`"
              />
            </div>
            <element-component
              v-else
              v-model="searchForm[col.field]"
              :label="col.label"
              :option="col"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card-btn> -->
  <!-- </b-overlay> -->
  <!-- 搜索模块-End -->
  </div>
</template>

<script>
import {
  BOverlay, BRow, BCol, BFormGroup, BButton,
} from 'bootstrap-vue'
import ElementComponent from '@/components/elementComponent.vue'
import MyTooltip from '@/components/myTooltip.vue';
import BCardBtn from '@/components/BCardBtn.vue';

export default {
  name: 'CSearch',
  components: {
    BOverlay,
    BRow,
    BCol,
    BFormGroup,
    MyTooltip,
    BButton,
    // BCardBtn,
    ElementComponent,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Array,
      default: () => [],
    },
    searchSpan: {
      type: Number,
      default: 4,
    },
  },
  data() {
    return {
      searchForm: {},
    }
  },
  computed: {
    columnsBase() {
      // const cols = this.columns.filter(o => o.searchBase)
      const cols = this.columns
      return cols
    },
    columnsOther() {
      const cols = this.columns.filter(o => !o.searchBase)
      return cols
    },
  },
  created() {
    this.columns.forEach(item => {
      if (item.search) {
        this.searchForm[item] = ''
      }
    });
  },
  methods: {
    // 获取搜索项的栅格
    getSearchSpan(item) {
      if (item.searchSpan) {
        return item.searchSpan
      }
      return this.searchSpan
    },
    searchReset() {
      Object.keys(this.searchForm).forEach(key => {
        this.searchForm[key] = ''
      })
      this.$emit('searchReset')
    },
    searchChange() {
      this.$emit('searchChange', this.searchForm)
    },
    // 国际化
    i18n(param) {
      return this.$t(`_components.${param}`)
    },
  },
}

</script>

<style lang='scss' scoped>

</style>
